var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoilshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 313.896,
    height: 38.384,
    viewBox: "0 0 313.896 38.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "foilshop",
    transform: "translate(-1407.87 -2154.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(1407.87 2154.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 1.507,
    height: 33.45,
    transform: "translate(80.495 4.458)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_577",
    transform: "translate(0 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    transform: "translate(0.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    d: "M53.083,1.4H46.641l-.14.42-.56,2.8-.14.42-.28,1.541V7l-.28.84L45.1,8.4h4.621A3.608,3.608,0,0,0,52.8,5.881h0L53.22,4.2V3.92l.42-1.961.14-.56Z",
    transform: "translate(15.679 -1.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    d: "M48.8,7.3H46.98L41.1,35.169h1.961a5.22,5.22,0,0,0,4.9-4.062L53,7.3Z",
    transform: "translate(14.077 0.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    d: "M21.026,30.629l7.142-15.265-4.2,19.886H29.71l4.9-22.967A4.526,4.526,0,0,0,34.05,8.5a4.03,4.03,0,0,0-3.5-1.4,6.818,6.818,0,0,0-1.681.14,5.648,5.648,0,0,0-4.2,3.5L17.385,25.728l-.14-14.985a3.348,3.348,0,0,0-2.8-3.5A5.744,5.744,0,0,0,12.9,7.1,6.777,6.777,0,0,0,8.842,8.5,7.047,7.047,0,0,0,6.6,12.284L1.7,35.251H7.442l4.2-19.886.56,14.844.14,1.961c0,.42.14.98.14,1.4a2.865,2.865,0,0,0,2.941,2.381,4.279,4.279,0,0,0,3.781-2.1l.14-.14a9.419,9.419,0,0,0,.98-1.541Z",
    transform: "translate(-1.7 0.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    d: "M25.087,30.549a4.764,4.764,0,0,0,.14,1.4,2.923,2.923,0,0,0,1.541,2.241,7.457,7.457,0,0,0,4.2.98H37.83a6.961,6.961,0,0,0,6.3-3.362,9.305,9.305,0,0,0,1.26-3.781L47.21,19.2H40.492l-.7,3.081h.7l-1.121,5.461v.14c-.28.84-.98,1.26-2.241,1.26H32.369a1.18,1.18,0,0,1-.98-.98v-.14L34.33,14.443a1.507,1.507,0,0,1,1.4-1.12H46.794L48.054,7.3H36.711a8.728,8.728,0,0,0-5.6,1.541,9.655,9.655,0,0,0-2.661,5.322s-3.081,14.706-3.221,15.266a3.48,3.48,0,0,0-.142,1.12Z",
    transform: "translate(7.683 0.961)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1451",
    d: "M1.1,14.4",
    transform: "translate(-1.1 3.806)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Approve",
    d: "M13.794.264a11.462,11.462,0,0,0,8.811-3.63L20.46-5.445a8.59,8.59,0,0,1-6.5,2.772A8.725,8.725,0,0,1,4.884-11.55a8.725,8.725,0,0,1,9.075-8.877,8.559,8.559,0,0,1,6.5,2.739l2.145-2.079a11.415,11.415,0,0,0-8.778-3.6C6.8-23.364,1.584-18.381,1.584-11.55S6.8.264,13.794.264ZM33.3.2a8.7,8.7,0,0,0,9.075-8.943,8.676,8.676,0,0,0-9.075-8.91c-5.247,0-9.108,3.7-9.108,8.91A8.729,8.729,0,0,0,33.3.2Zm0-2.772A5.791,5.791,0,0,1,27.39-8.745,5.764,5.764,0,0,1,33.3-14.883c3.366,0,5.874,2.409,5.874,6.138S36.663-2.574,33.3-2.574ZM55.77-17.655a7.5,7.5,0,0,0-6.3,2.805v-2.64H46.431V0H49.6V-9.009c0-3.8,2.178-5.808,5.544-5.808,3,0,4.719,1.683,4.719,5.115V0H63.03V-10.065C63.03-15.213,60.027-17.655,55.77-17.655ZM73.59.2c4.653,0,7.557-2.013,7.557-5.181,0-6.8-11.088-3.432-11.088-7.557,0-1.386,1.353-2.409,4.125-2.409a9.134,9.134,0,0,1,5.049,1.386l1.353-2.508a12.727,12.727,0,0,0-6.369-1.584c-4.488,0-7.293,2.112-7.293,5.247,0,6.963,11.055,3.564,11.055,7.491,0,1.485-1.221,2.376-4.158,2.376a11.239,11.239,0,0,1-6.138-1.815l-1.32,2.508A12.623,12.623,0,0,0,73.59.2ZM97.911-17.49v9.042c0,3.762-2.112,5.808-5.412,5.808-3,0-4.719-1.716-4.719-5.148v-9.7H84.612V-7.425c0,5.148,3,7.623,7.524,7.623a7.116,7.116,0,0,0,5.94-2.838V0h3V-17.49Zm30.756-.165a7.882,7.882,0,0,0-6.732,3.234c-1.155-2.178-3.4-3.234-6.072-3.234a7.089,7.089,0,0,0-6.039,2.772V-17.49h-3.036V0h3.168V-9.009c0-3.8,2.079-5.808,5.247-5.808,2.871,0,4.521,1.683,4.521,5.115V0h3.168V-9.009c0-3.8,2.079-5.808,5.247-5.808,2.871,0,4.521,1.683,4.521,5.115V0h3.168V-10.065C135.828-15.213,132.924-17.655,128.667-17.655Zm19.041,0a11.647,11.647,0,0,0-7.227,2.244l1.32,2.376a8.845,8.845,0,0,1,5.544-1.881c3.135,0,4.686,1.551,4.686,4.224v.627h-5.016c-5.214,0-7.029,2.31-7.029,5.115,0,3.036,2.508,5.148,6.468,5.148,2.739,0,4.686-.924,5.742-2.508V0h3V-10.56C155.2-15.345,152.493-17.655,147.708-17.655Zm-.726,15.411c-2.409,0-3.861-1.089-3.861-2.838,0-1.485.891-2.706,4.026-2.706h4.884v2.442A5.072,5.072,0,0,1,146.982-2.244Zm23.034-15.411a7.442,7.442,0,0,0-6.1,2.805v-9.636h-3.168V0h3.036V-2.772A7.389,7.389,0,0,0,170.016.2a8.516,8.516,0,0,0,8.844-8.943A8.489,8.489,0,0,0,170.016-17.655Zm-.264,15.081c-3.333,0-5.874-2.442-5.874-6.171a5.756,5.756,0,0,1,5.874-6.138,5.764,5.764,0,0,1,5.907,6.138A5.791,5.791,0,0,1,169.752-2.574ZM182.919,0h3.168V-24.486h-3.168ZM207.6-8.646c0-5.379-3.6-9.009-8.646-9.009a8.566,8.566,0,0,0-8.778,8.91c0,5.214,3.762,8.943,9.4,8.943a8.779,8.779,0,0,0,6.9-2.838l-1.749-2.046a6.53,6.53,0,0,1-5.049,2.112c-3.465,0-5.94-2.046-6.336-5.115h14.19C207.57-7.986,207.6-8.382,207.6-8.646Zm-8.646-6.336a5.454,5.454,0,0,1,5.61,5.016h-11.22A5.452,5.452,0,0,1,198.957-14.982ZM216.678.2c4.653,0,7.557-2.013,7.557-5.181,0-6.8-11.088-3.432-11.088-7.557,0-1.386,1.353-2.409,4.125-2.409a9.134,9.134,0,0,1,5.049,1.386l1.353-2.508a12.727,12.727,0,0,0-6.369-1.584c-4.488,0-7.293,2.112-7.293,5.247,0,6.963,11.055,3.564,11.055,7.491,0,1.485-1.221,2.376-4.158,2.376a11.239,11.239,0,0,1-6.138-1.815l-1.32,2.508A12.623,12.623,0,0,0,216.678.2Z",
    transform: "translate(89.66 33)",
    fill: "#fff",
    opacity: 0.796
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoilshop);
export default __webpack_public_path__ + "static/media/foilshop.e3dd961d251ec1d5d423104ae0ad7a7a.svg";
export { ForwardRef as ReactComponent };